import './Hierarchy.css';

export const HierarchyConditionsHelper = {
    getTriggerQuestion(condition, allQuestions) {
       return condition?.triggerQuestionId ? allQuestions.find(t => t.id === condition.triggerQuestionId) : null;
    },

    getConcatenatedAnswers(triggerQuestion, condition) {
        if (triggerQuestion) {
            if (triggerQuestion.$componentType === "YesNoQuestion") {
                const answers = [];

                if (condition.requiredAnswers.includes("True")) {
                    answers.push(triggerQuestion.labelForYes);
                }

                if (condition.requiredAnswers.includes("False")) {
                    answers.push(triggerQuestion.labelForNo);
                }

                return answers.join(", ");
            }

            return triggerQuestion.options
                .filter(o => condition.requiredAnswers.includes(o.id))
                .map(o => o.name)
                .join(', ');
        }

        return "";
    }
}